export enum LoadingStatus {
  Loading,
  Success,
  Failure,
}
